import styled from 'styled-components';
import { Typography } from '../../../stories/atoms';
import { Button } from '../../../stories/molecules';

export const StyledTypography = styled(Typography)`
  color: ${({ theme: { color, palette } }) =>
    palette.mode === 'dark' ? color.secondaryDarkTextGray : color.secondaryTextGray};
  flex: 1;
`;

export const StyledButton = styled(Button)`
  height: ${({ theme }) => theme.spacing(8)};
  width: fit-content;
  padding: ${({ theme }) => theme.spacing(2, 2)};
  border-radius: ${({ theme }) => theme.spacing(1)};
`;
